import React from 'react';
import { Helmet } from "react-helmet";
import GooglePlayIcon from '../assets/android-app_v1.png';
import Appstore from '../assets/ios-app_v1.png';
import Header from '../master_root/header';
export default function Appdownload() {
  return (
         <div >
     <Header /> 
   <div className='app_header_height'></div>
   
    <div className="container_roots">

      <Helmet>
        <title>Download EditorTask App - Freelance Jobs & Talent Showcase</title>
        <meta name="description" content="Download the EditorTask mobile app to find freelance jobs, showcase your creative portfolio, and get hired. Available for Android and iOS." />
        <meta name="keywords" content="EditorTask app, job portal app, freelance app, download app, creative jobs app, India freelance, editor jobs mobile" />
        <meta name="author" content="editortask.com" />
        <meta name="robots" content="index, follow" />

        <meta property="og:title" content="Download EditorTask App - Freelance Jobs & Talent Showcase" />
        <meta property="og:description" content="Explore freelance opportunities and post creative work easily with the EditorTask mobile app. Available now!" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.editortask.com/app-download" />
        <meta property="og:image" content="https://www.editortask.com/images/editortask_app_banner.png" />
      </Helmet>

      <div className="container_size">
        <h2 className="contact-title">Download the EditorTask App</h2>

        <p className="text-md mt-2">
          Access freelance jobs and showcase your talent anytime, anywhere. Our mobile app is the easiest way to manage your profile, upload your work, and connect with job providers in real-time.
        </p>

        <div className="download-buttons mt-4">
          <a href="https://play.google.com/store/apps/details?id=com.editortask.app" target="_blank" rel="noopener noreferrer">
            <img src={GooglePlayIcon} alt="Download on Google Play" className="download-btn" />
          </a>

          <a href="https://apps.apple.com/app/id123456789" target="_blank" rel="noopener noreferrer">
            <img src={Appstore} alt="Download on App Store" className="download-btn" />
          </a>
        </div>

        <div className="app-features mt-6">
          <h3>📱 App Features:</h3>
          <ul>
            <li>✔️ Browse & Apply for Jobs</li>
            <li>✔️ Upload Creative Work & Portfolios</li>
            <li>✔️ Chat with Job Providers</li>
            <li>✔️ Get Notified Instantly</li>
            <li>✔️ Showcase Skills with Projects</li>
          </ul>
        </div>

        <div className="guide-tipes-div mt-4">
          <b>Note:</b> Our app is available for both Android and iOS. Ensure you're logged in to sync your profile and job activity.
        </div>
      </div>
    </div>
    </div>
  );
}
